// externals
import type { Reducer } from 'redux';

// consts/enums
import {
    REPORT_ISSUE_REQUEST,
    REPORT_ISSUE_SUCCESS,
    REPORT_ISSUE_FAILURE,
    REPORT_ISSUE_RESET
} from '../actionTypes/reportIssueActionTypes';

// types
import type { ReportIssueState } from '@makemydeal/dr-dash-types';

export const reportIssueInitialState: ReportIssueState = {
    isSubmitting: false,
    isSuccess: false,
    isFailure: false
};

export type ReportIssueReducer = Reducer<ReportIssueState>;

export const reducer: ReportIssueReducer = (state: ReportIssueState = reportIssueInitialState, action: any) => {
    switch (action.type) {
        case REPORT_ISSUE_REQUEST: {
            return {
                isSubmitting: true,
                isSuccess: false,
                isFailure: false
            };
        }
        case REPORT_ISSUE_SUCCESS: {
            return {
                isSubmitting: false,
                isSuccess: true,
                isFailure: false
            };
        }
        case REPORT_ISSUE_FAILURE: {
            return {
                isSubmitting: false,
                isSuccess: false,
                isFailure: true
            };
        }
        case REPORT_ISSUE_RESET: {
            return reportIssueInitialState;
        }
        default: {
            return state;
        }
    }
};
